import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['hiddenContent']

  toggleContent() {
    this.hiddenContentTarget.classList.remove("hidden")
  }

  hideIfBlank(event) {
    const value = event.currentTarget.value;
    if(value.length === 0) {
      this.hiddenContentTarget.classList.add("hidden")
    }
  }
}